"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInternalException = exports.createException = exports.RegistryError = exports.RegistryErrorCode = void 0;
var RegistryErrorCode;
(function (RegistryErrorCode) {
    RegistryErrorCode["IncorrectEntryArguments"] = "IncorrectEntryArguments";
    RegistryErrorCode["IncorrectLibraryParams"] = "IncorrectLibraryParams";
    RegistryErrorCode["IncorrectLoaderArguments"] = "IncorrectLoaderArguments";
    RegistryErrorCode["IncorrectBundleExport"] = "IncorrectBundleExport";
    RegistryErrorCode["IncorrectBatches"] = "IncorrectBatches";
    RegistryErrorCode["FetchError"] = "FetchError";
    RegistryErrorCode["BundleEvaluationError"] = "BundleEvaluationError";
    RegistryErrorCode["InternalException"] = "InternalException";
})(RegistryErrorCode = exports.RegistryErrorCode || (exports.RegistryErrorCode = {}));
/**
 * NOTE: all error methods should be defined as the arrow functions
 * because of typescript issue when target is set `es5`
 */
var RegistryError = /** @class */ (function (_super) {
    __extends(RegistryError, _super);
    function RegistryError(message, code) {
        var _this = _super.call(this, message) || this;
        _this.hints = [];
        _this.messages = [];
        _this.withParentError = function (error) {
            _this.parent = error;
            return _this;
        };
        _this.withDetails = function (message, code) {
            _this.messages.push({
                message: message,
                code: code,
            });
            return _this;
        };
        _this.withLibrary = function (library) {
            return _this.withDetails("Library: " + library);
        };
        _this.withUrl = function (url) {
            return _this.withDetails("URL: " + url);
        };
        _this.withRuntime = function (runtime) {
            if (runtime) {
                _this.withDetails("Runtime: " + runtime);
            }
            return _this;
        };
        _this.withComponent = function (component, part, parts) {
            _this.withDetails("Component: " + component);
            if (part) {
                _this.withDetails("Component Part: " + part);
            }
            if (parts && (parts === null || parts === void 0 ? void 0 : parts.length)) {
                _this.withDetails("Available Parts: " + parts.join(', '));
            }
            return _this;
        };
        _this.withMissMatch = function (expected, received) {
            return _this.withDetails("Expected value: " + expected).withDetails("Received value: " + received);
        };
        _this.withOriginalErrorMessage = function (message) {
            return _this.withDetails("Original Error Message: " + message);
        };
        _this.withHint = function (hint) {
            _this.hints.push(hint);
            return _this;
        };
        _this.name = _this.constructor.name;
        _this.code = code;
        _this.messages.push({
            message: message,
            code: code,
        });
        Object.defineProperty(_this, 'message', {
            get: function () {
                var _a = _this.messages, header = _a[0], rows = _a.slice(1);
                var title = "" + (header.code ? header.code + ". " : '') + header.message;
                var messages = [title];
                rows.forEach(function (row) {
                    messages.push("  \u2013 " + row.message);
                });
                if (_this.hints.length) {
                    messages.push('');
                    messages.push("Hints:");
                    messages.push(_this.hints.map(function (m) { return "  \u2013 " + m; }).join('\n'));
                }
                if (_this.parent) {
                    messages.push('');
                    messages.push("Parent Error:");
                    messages.push(_this.parent.message
                        .split('\n')
                        .map(function (m) { return "  " + m; })
                        .join('\n'));
                }
                return messages.join('\n');
            },
        });
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, RegistryError);
        }
        return _this;
    }
    return RegistryError;
}(Error));
exports.RegistryError = RegistryError;
exports.createException = function (message, code) {
    var e = new RegistryError(message, code);
    if (Error.captureStackTrace) {
        Error.captureStackTrace(e, exports.createException);
    }
    return e;
};
exports.createInternalException = function (message) {
    if (message === void 0) { message = 'Registry internal exception or unreachable code.'; }
    var e = new RegistryError(message, RegistryErrorCode.InternalException);
    if (Error.captureStackTrace) {
        Error.captureStackTrace(e, exports.createInternalException);
    }
    return e;
};
//# sourceMappingURL=RegistryError.js.map